import { toWSDateString, WSAlert } from "@wingspanhq/fe-component-library";
import { PayableStatus } from "@wingspanhq/wingspan-api-sdk";
import { useHistory } from "react-router-dom";
import { queriesPayableRows, queriesPayeeRows } from "@query";
import { selectorSearchRowName } from "../../../shared/selectors/selectorSearchRowName";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";

interface Props {
  payeeId: string;
}

const payableStatusToSentenceMap: Partial<Record<PayableStatus, string>> = {
  [PayableStatus.CANCELLED]: "A cancelled",
  [PayableStatus.CREATED]: "A draft",
  [PayableStatus.OPENED]: "An open",
  [PayableStatus.PAID]: "A paid",
  [PayableStatus.PAYMENT_IN_TRANSIT]: "A payment in transit",
  [PayableStatus.PENDING]: "A pending"
};

export const AlertExistingPayable: React.FC<Props> = props => {
  const history = useHistory();

  const queryPayables = queriesPayableRows.searchPayableRows.useQuery({
    filter: {
      metadata_invoiceType: { ne: "approvedInvoicesPayment" },
      metadata_creationSource: { ne: "personalPaylink" },
      payeeId: { eq: props.payeeId },
      status: {
        anyOf: [
          PayableStatus.CREATED,
          PayableStatus.OPENED,
          PayableStatus.PENDING
        ]
      }
    },
    page: {
      size: 1
    }
  });
  const xWingspanAccount = useXWingspanPayerId();
  // Name off the search row's server-resolved `profile.resolvedName`, the same
  // string the payables table shows for this contractor.
  const queryPayeeRow = queriesPayeeRows.searchPayeeRows.useQuery({
    filter: { id: { eq: props.payeeId } },
    page: { size: 1 },
    xWingspanAccount
  });

  const payable = queryPayables.data?.data?.[0];
  const payee = queryPayeeRow.data?.data?.[0];

  if (!payable || !payee || !payable.status) {
    return null;
  }

  return (
    <WSAlert
      mt="L"
      theme="warning"
      action={{
        text: "Edit payable",
        onClick: () => {
          history.push(`/member/invoices/payables/${payable.id}/edit`);
        }
      }}
    >
      {payableStatusToSentenceMap[payable.status]} payable exists to{" "}
      {selectorSearchRowName(payee)} due{" "}
      {toWSDateString(payable.dueDate, "monthDayYear")}.
    </WSAlert>
  );
};
